<template>
  <div class="overview">
    <Header title="数据概览"/>
    <div class="overview__row" flex="box:mean" >
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">总交易额</div>
        <div>￥{{order_amt}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center"  v-if="dl_type=='-1' ||agentid==''">
        <div class="overview__title">一级代理</div>
        <div>{{one_agent_num}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center"  v-if="dl_type=='-1'|| dl_type=='0'  ||agentid==''">
        <div class="overview__title">二级代理</div>
        <div>{{two_agent_num}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center"  v-if="dl_type=='-1'|| dl_type=='0' || dl_type=='1'  ||agentid==''">
        <div class="overview__title">三级代理</div>
        <div>{{three_agent_num}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center" v-if="dl_type=='-1'|| dl_type=='0' || dl_type=='1' || dl_type=='2'  ||agentid==''">
        <div class="overview__title">总商户数</div>
        <div>{{agent_num}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header'
import util from '@/libs/util.js'
import * as agentService from '@/api/sys/agent'
export default {
  components: { Header },
  name: 'OverView',

  data () {
    return {
      one_agent_num: '',
      two_agent_num: '',
      three_agent_num: '',
      agent_num: '',
      order_amt: '',
      agentid: util.cookies.get('agentid'),
      is_sys_kf: util.cookies.get('is_sys_kf'),
      dl_type: util.cookies.get('dl_type')

    }
  },

  created () {
    this.chartData = {
      columns: ['test', '我的佣金', '利润', '占比', '其他', '我的佣金'],
      rows: [
        { 日期: '1月1日', 成本: 1523, 利润: 1523, 占比: 0.12, 其他: 100 },
        { 日期: '1月2日', 成本: 1223, 利润: 1523, 占比: 0.345, 其他: 100 },
        { 日期: '1月3日', 成本: 2123, 利润: 1523, 占比: 0.7, 其他: 100 },
        { 日期: '1月4日', 成本: 4123, 利润: 1523, 占比: 0.31, 其他: 100 }
      ]
    }
    this.chartSettings = {}
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      formData4.append('dl_type', util.cookies.get('dl_type'))
      formData4.append('xt_id', util.cookies.get('xt_id'))
      agentService.getStatisticsHomedl(formData4).then(data => {
        if (data != null && data != '') {
          this.one_agent_num = data.one_agent_num
          this.two_agent_num = data.two_agent_num
          this.three_agent_num = data.three_agent_num
          this.agent_num = data.agent_num
          this.order_amt = data.order_amt
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  width: 100%;
  border-radius: 10px;
  height: 1.3rem;
  min-height: 110px;
  &__col {
    font-size: 0.15rem;
    margin-top: 15px;
  }
  &__col:not(:last-child){
        border-right: 1px solid rgb(242, 242, 242);
  }
  &__title {
    color: rgb(137, 149, 160);
    margin-bottom: 10px;
  }
}
</style>
